import { getPerformance, trace } from "firebase/performance";
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
import { getApps } from "firebase/app";
import { createPersistedState } from "~/utils/persistedState";

export type sentOffers = sentOffer[] | undefined;
type existOffer = sentOffer 

interface userState {
  userProfil: userProfil ;
  userSavedAnnounce: userAnnoucements;
  userAllAnnounce: userAnnoucements;
  userSentOffers: userOffers;
  userSavedSearch: savedSearch[],
  hasNewOffer : boolean,
  emailExist: boolean,
  existOffers : existOffer
  counters:{
    myAnnounce: number,
    myOffers:number,
    savedSearch: number
  }
  pendingStats :{
    saveAnnounce : boolean
    sendOffer: boolean
    announceStatus:boolean
    archive: boolean
    checkoffer: boolean
    activer: boolean
    restorer:boolean
  }
  factures: Facture[],
  pendingAuth: boolean
}

const state = (): userState => ({
  userProfil: {} as userProfil,
  userSavedAnnounce:{
    announcements: [],
    totalCount: 0,
  } as userAnnoucements,
  userAllAnnounce: {
    announcements: []
  } as unknown as userAnnoucements,
  userSentOffers: {} as userOffers,
  existOffers : {} as existOffer,
  userSavedSearch: [],
  hasNewOffer : false,
  emailExist: false,
  counters:{
    myAnnounce: 0,
    myOffers:0,
    savedSearch:0
  },
  pendingStats :{
    saveAnnounce : false,
    sendOffer: false,
    announceStatus: false,
    archive:false,
    checkoffer: true,
    activer: false,
    restorer: false
  },
  factures: [],
  pendingAuth: false,
});

const getters = {
  getUserProfil: (state: userState) => {
    return state.userProfil;
  },

  getUserNotifCount: (state: userState) => {

    return (action: boolean) => {
      if (action) { return 0 }
      else { return state.userProfil?.newNotificationsNumber }
    }
  },
  getUserAnnounce: (state: userState) => {
    return state.userAllAnnounce;
  },
  getUserSentOffer: (state: userState) => {
    return state.userSentOffers;
  },
  getUserSavedAnnounce: (state: userState) => {
    return state.userSavedAnnounce;
  },
  getUserSavedSearch: (state: userState) => {

    return state.userSavedSearch;
  },
  getIsUserConnected : (state : userState)=>{
   
    
    return Object.keys(state.userProfil).length != 0
  },
  getHasNewOffer : (state : userState)=>{
    
    return state.hasNewOffer
  },
  getIsUserActive : (state : userState)=>{
    
    if (state.userProfil.activated) {
        return true
    }else{
      return false
    }
  },
  getexistOffers : (state : userState)=>{
      return state.existOffers
  },
  getisOffersExist : (state : userState)=>{
    return Object.keys(state.existOffers).length != 0
},
// counters stats
getMyCount: (state: userState)=>{
return state.counters
},
// pending stats
getPendingStats: (state: userState) => {
  return state.pendingStats
},
};

export const useDashboardStore = defineStore("dashboardStore", {
  state,
  getters,
  actions: {

    async fetchUserByToken() {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");

      try {
        if (cookie.value) {
          const response = await $fetch<userProfil>("/users/current-user", {
            method: "GET",
            headers: {
              Authorization: "Bearer " + cookie.value,
            },
  
            baseURL: runTimeConfig.public.baseUrl,
          });

          this.userProfil = response;
        }


      } catch (error) {

        // console.log(error);
        throw new Error(String(error))
        
        
        
      }
    },
    async checkNewOffer() {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");

      try {
        const response = await $fetch<any>("/offers/check-new", {
          method: "GET",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },

          baseURL: runTimeConfig.public.baseUrl,
        });

        this.hasNewOffer = response.newOffers;

      } catch (error) {

        throw new Error("");
        
        
      }
    },
    async fetchUserAllAnnounce(  pageNumber : number = 1 , isScroll : boolean = false , titleFilter : string = '' , getDraft : boolean = false) {
      if (!isScroll) {
        this.userAllAnnounce.announcements = [];
      }
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'fetchUserAllAnnounce');
        fetchTrace.start();
      }
      try {
        const response = await $fetch<userAnnoucements>("/announcements/my-announcements", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body : {
            titleFilter : titleFilter,
            pageNumber: pageNumber,
            getDraft : getDraft,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        
        this.userAllAnnounce.totalCount = response.totalCount
        response.announcements.map((item: any, index: number) => {
          let waitingOffersNbr: number = 0
          let acceptedOffersNbr: number = 0

          let allRefused: boolean = false
          for (let i = 0; i < item.offers.length; i++) {
            const element = item.offers[i];


            
            
            if (element.status == 'ACCEPTED') {
              waitingOffersNbr = -1;
              acceptedOffersNbr++;
            
            }
            
            if (element.status == 'SOLD') {
              waitingOffersNbr = -2;
              break;
            }
            if (element.status == 'WAITING') {
              waitingOffersNbr = 0
              waitingOffersNbr++;
              break;
            } else if (i === item.offers.length - 1 && element.status == 'REFUSED' && waitingOffersNbr === 0) {
                allRefused = true
            }


          }
          
          if (isScroll) {
            this.userAllAnnounce.announcements?.push(item)
          }else{
            this.userAllAnnounce.announcements = response.announcements
          }
        
          this.userAllAnnounce.announcements[index].offerState = { OffersWaiting: waitingOffersNbr,acceptedOffers: acceptedOffersNbr, allRefused: allRefused }
          
        })
        
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },

    // saved announce fetching 
    async saveAnnounce(id: number) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      this.pendingStats.saveAnnounce = true;
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'saveAnnounce');
        fetchTrace.start();
      }
      try {
         await $fetch("/announcements/save", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: {
            announcementId: id,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });

      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      }finally{
        this.pendingStats.saveAnnounce = false
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }

    },
    async UnsaveAnnounce(id: number) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      this.pendingStats.saveAnnounce = true
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'UnsaveAnnounce');
        fetchTrace.start();
      }
      try {
        const response = await $fetch("/announcements/un-save", {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: {
            announcementId: id,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        
        if (response && response.success) {
          // Remove the unsaved announcement
          this.userSavedAnnounce.announcements = this.userSavedAnnounce.announcements.filter(
            (announcement: any) => announcement.id !== id
          );
    
          // Decrease the total count if it's greater than 0
          if (this.userSavedAnnounce.totalCount > 0) {
            this.userSavedAnnounce.totalCount -= 1;
          }
    
        }
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      }finally{
        this.pendingStats.saveAnnounce = false
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }

    },
    async unSaveResearches(id: number) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      this.pendingStats.saveAnnounce = true
      try {
        const response = await $fetch("/researches/un-save", {
          method: "DELETE",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: {
            researchId: id,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        if (response && response.success) {
          // Remove the unsaved announcement
          this.userSavedSearch = this.userSavedSearch.filter(
            (announcement) => announcement.id !== id
          );
    
    
        }
        // console.log(response);
        
        // console.log(this.userSavedSearch[0]);
        // console.log(this.userSavedSearch);
        
        
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      }finally{
        this.pendingStats.saveAnnounce = false

      }

    },
    async fetchUserSavedAnnounce(pageNumber : number = 1 , titleFilter : string = '' , isScroll? : boolean) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      try {
        const response = await $fetch<userAnnoucements>("/announcements/get-my-saved", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body : {
            titleFilter : titleFilter,
            pageNumber: pageNumber
                    },
          baseURL: runTimeConfig.public.baseUrl,
        });

        this.userSavedAnnounce.totalCount =  response.totalCount;
        if (isScroll) {
          this.userSavedAnnounce.announcements = [...this.userSavedAnnounce.announcements, ...response.announcements]
        }else{
          this.userSavedAnnounce.announcements = response.announcements
         
        }
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      }
    },

        // send user offer
    async fetchUserSentOffers(pageNumber : number = 1 , titleFilter : string = '') {
          const runTimeConfig = useRuntimeConfig();
          const cookie = useCookie("userToken");
          
          this.userSentOffers.offers =[]
          try {
            const response = await $fetch<userOffers>("/offers/get-my-sent-offers", {
              method: "POST",
              headers: {
                Authorization: "Bearer " + cookie.value,
              },
              body : {
                titleFilter : titleFilter,
                pageNumber : pageNumber
              },
              baseURL: runTimeConfig.public.baseUrl,
    
            });
    
            this.userSentOffers = response;
          } catch (error) {
            // console.log(error);
              throw new Error("erreur")
          }
    },
    async sendNewOffer(
      amount:  string,
      announcementId: number, 
      announcementTitle : string , 
      userId: number, 
      fromUserName : string,
      toUserName : string , 
      toUserMail : string  ,
      ) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'sendNewOffer');
        fetchTrace.start();
      }

      try {
        await $fetch("/offers/send-new", {
            method: "POST",
            headers: {
              Authorization: "Bearer " + cookie.value,
              "Content-Type": "application/json",
            },
            body: {
              amount: amount,
              announcementId: announcementId, 
              announcementTitle : announcementTitle,
              toUserId: userId,
              fromUserName : fromUserName,
              toUserName : toUserName,
              toUserMail : toUserMail,
            },
            baseURL: runTimeConfig.public.baseUrl,
          });
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async isOfferOfferExist(announcementId: string | string []) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");

      if (!cookie.value) {
        return
      }
      this.pendingStats.checkoffer = true;

      try {
        if (this.getisOffersExist && this.existOffers.announcementId === Number(announcementId)) {
          return
        }
        const response
          = await $fetch<existOffer>("/offers/check-offer-exist", {
            method: "POST",
            headers: {
              Authorization: "Bearer " + cookie.value,
              "Content-Type": "application/json",
            },
            body: {
              announcementId: announcementId
            },
            baseURL: runTimeConfig.public.baseUrl,
          });
          this.existOffers = response
      } catch (error) {
        throw new Error(String(error))
      }
      finally{
        this.pendingStats.checkoffer = false
      }
    },
    async editOfferApi (body : any){
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      const dashStore = useDashboardStore();
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'editOffer');
        fetchTrace.start();
      }
      try {
        this.pendingStats.sendOffer = true
        await $fetch("/offers/edit", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: body,
          baseURL: runTimeConfig.public.baseUrl,
        });
        await dashStore.fetchUserAllAnnounce(1, false, '', true)

        return false
    } catch (error) {
      throw new Error(String(error))
    }finally{
      this.pendingStats.sendOffer = false
      if (fetchTrace) {
        fetchTrace.stop();
      }
    }
    },
    async editOffer ( 
      amount: String ,
      offerId : number){
        this.editOfferApi({amount : amount, offerId : offerId})
    },
    async acceptRefuseOffer(
      offerId : number,
      status : string,
      offerFromUserId : number,
      announcementId: number, 
      offerFromUserName : string,
      offerFromUserMail: string,
      announcementTitle : string , 
       )
       {
        this.editOfferApi({
          offerId : offerId,
          status : status,
          offerFromUserId : offerFromUserId,
          announcementId: announcementId, 
          offerFromUserName : offerFromUserName,
          offerFromUserMail: offerFromUserMail,
          announcementTitle : announcementTitle 
         })
     
    },

    async setAnnounceSellStatus (announcementId : number , sellState : string){
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      this.pendingStats.announceStatus = true
      let apiUrl = ''      
      if (sellState === 'SOLD') {
        apiUrl = '/announcements/set-sold'
      }
      else if (sellState === 'TO_SELL') {
        apiUrl = '/announcements/set-to-sell'
      }
      else {
          return
      }
      
      try {
        await $fetch( apiUrl, {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: {
            announcementId: announcementId,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
      } catch (error) {
        throw new Error(String(error))
      }finally{
        this.pendingStats.announceStatus = false

      }
    },


    async archiveAnnounce(id: number) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'archiveAnnounce');
        fetchTrace.start();
      }
      try {
        this.pendingStats.archive = true
        const res = await useFetch(() => "/announcements/archive", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: {
            announcementId: id,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        return res.data    
      } catch (error) {
        throw new Error(String(error))
      }finally{
        this.pendingStats.archive = false
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async restoredArchiveAnnounce(id: number) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'restoredArchiveAnnounce');
        fetchTrace.start();
      }
      try {
        this.pendingStats.restorer = true
        const res =  await useFetch(() => "/announcements/restore", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: {
            announcementId: id,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        return res.data    

      } catch (error) {
        throw new Error(String(error))
      }finally{
        this.pendingStats.restorer = false
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },

    async activerAnnounce(id: number) {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      const cookieUserId = useCookie("userId");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'activerAnnounce');
        fetchTrace.start();
      }
      try {
        this.pendingStats.activer = true
          const res = await useFetch(() => "/announcements/activer", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: {
            announcementId: id,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });

        // Track successful announcement activation
        trackAnnouncementActivated({
          announcementId: id,
          userId: cookieUserId.value || undefined,
          creditsUsed: Number(runTimeConfig.public.activateAnnnouncementCredits)
        });

        return res.data
      } catch (error) {
        throw new Error(String(error))
      }finally{
        this.pendingStats.activer = false
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async fetchUserSavedSearch(filter : string = '') {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'fetchUserSavedSearch');
        fetchTrace.start();
      }
      try {
        const response = await $fetch<savedSearch[]>("/researches/find-by-user", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body : {
            filter: filter
          },
          baseURL: runTimeConfig.public.baseUrl,

        });

        this.userSavedSearch = response;

      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },

    // buy announce api
    //Increment Max Announcements
    async incrementMaxAnnouncements(){
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      try {
        await $fetch<savedSearch[]>("/users/edit-max-announcements", {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          body : {
            incrementBy: 1
          },
          baseURL: runTimeConfig.public.baseUrl,

        });

      //  console.log(response);
       this.userProfil.maxAnnouncements = this.userProfil.maxAnnouncements + 1

      } catch (error) {
      throw new Error(String(error))
      }
    },

    async generateClicToPayUrl(packId: string){
      const runtimeConfig = useRuntimeConfig();
      const token = useCookie("userToken");

       try {
        const response = await $fetch<any>('/payment/new', {
          baseURL: runtimeConfig.public.baseUrl,
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token.value}`,
            'Content-Type': 'application/json',
          },
          body: {
            packId,
            pageView: 'DESKTOP',
          },
        });
        if(response.formUrl){
            navigateTo(response.formUrl,{ external: true })
        }


      } catch (error) {
        console.error('ClicToPay error:', error);
        throw new Error(String(error));
      }
      
      
    },
    async confirmPayment(orderId:string){
      const runtimeConfig = useRuntimeConfig();
      const token = useCookie("userToken");
      const cookieUserId = useCookie("userId");
      
      try {
        const response = await $fetch<any>('/payment/confirm', {
            baseURL: runtimeConfig.public.baseUrl,
            method: 'POST',
            headers: {
              Authorization: `Bearer ${token.value}`,
              'Content-Type': 'application/json',
            },
            body: {
              orderId: orderId
            }
        });
        // console.log(response);
        
        if(response.data.status.includes('succes')){
          this.userProfil.additionalCredits += response.data.additionalCredits
          this.userProfil.freeCredits += response.data.freeCredits
          trackPurchasedStatus(true)
          // Track credits purchased
          trackCreditsPurchased({
            userId: cookieUserId.value || undefined,
            creditsAdded: response.data.additionalCredits,
            freeCreditsAdded: response.data.freeCredits
          });
        } else {
          trackPurchasedStatus(false)
        }
      } catch (error) {
        console.error('confirm Payment error:', error);
        throw new Error(String(error));
      }
    },
    async getPaymentByOrderID(orderId:string){
      const runtimeConfig = useRuntimeConfig();
      const token = useCookie("userToken");
       try {
        const response = await $fetch<any>('/payment/find/'+orderId, {
            baseURL: runtimeConfig.public.baseUrl,
            method: 'GET',
            headers: {
              Authorization: `Bearer ${token.value}`,
              'Content-Type': 'application/json',
            },
           
        });
        return response
      } catch (error) {
        console.error('confirm getPaymentByOrderID error:', error);
        throw new Error(String(error));
      }
  },
    async getMyFactures(){

      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      try {
        const response = await $fetch<Facture[]>("/factures/get-my-factures", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
          },
          
          baseURL: runTimeConfig.public.baseUrl,

        });
  
       if(response){
        this.factures = response
      }

      } catch (error) {
      throw new Error(String(error))
      } 
    },
    async uploadInvoice(factureID:number){
      const runtimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
    
      try {
        const response = await fetch(`${runtimeConfig.public.baseUrl}/factures/invoices`, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + cookie.value,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ factureId: factureID }),
        });
    
        if (!response.ok) throw new Error("Failed to download PDF");
        
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const factureRef= response.headers.get('x-facture-ref');
        const link = document.createElement("a");
        link.href = url;
        link.download = `recu_topauto_${factureRef}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading invoice:", error);
      }
      
      
    },
    // counters
    //Count My announcements
    async countUserAnnounce() {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'countUserAnnounce');
        fetchTrace.start();
      }
      try {
        if (cookie.value) {
          const response = await $fetch<any>("/announcements/count-my-announcements", {
            method: "GET",
            headers: {
              Authorization: "Bearer " + cookie.value,
            },
  
            baseURL: runTimeConfig.public.baseUrl,
          });

         this.counters.myAnnounce = response.count
        }
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async countUserOffers() {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'countUserOffers');
        fetchTrace.start();
      }
      
      try {
        if (cookie.value) {
          const response = await $fetch<any>("/offers/count-my-sent-offers", {
            method: "GET",
            headers: {
              Authorization: "Bearer " + cookie.value,
            },
  
            baseURL: runTimeConfig.public.baseUrl,
          });

         this.counters.myOffers = response.count
        }
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async countUserSavedSearch() {
      const runTimeConfig = useRuntimeConfig();
      const cookie = useCookie("userToken");
      let fetchTrace;
      if (getApps().length > 0) {
        const performance = getPerformance();
        fetchTrace = trace(performance, 'countUserSavedSearch');
        fetchTrace.start();
      }

      try {
        if (cookie.value) {
          const response = await $fetch<any>("/researches/count-my-saved", {
            method: "GET",
            headers: {
              Authorization: "Bearer " + cookie.value,
            },
  
            baseURL: runTimeConfig.public.baseUrl,
          });

         this.counters.savedSearch = response.count
        }
      } catch (error) {
        // console.log(error);
        throw new Error(String(error))
      } finally {
        if (fetchTrace) {
          fetchTrace.stop();
        }
      }
    },
    async signInWithGoogle() {
      const auth = getAuth();
      const runTimeConfig = useRuntimeConfig();
      const isMobileAuthFlow = (): boolean => {
        if (process.server) {
          return false;
        }

        const rawValue = new URLSearchParams(window.location.search).get('mobileAuth');
        if (!rawValue) {
          return false;
        }

        const normalized = rawValue.trim().toLowerCase();
        return normalized === '1' || normalized === 'true' || normalized === 'yes';
      };
    
      const cookie = useCookie("userToken", { maxAge: 5184000 });
      const cookieId = useCookie("userId", { maxAge: 5184000 });
    
      try {
        this.pendingAuth = true;
        this.emailExist = false;
        // Ensure each attempt starts clean so user can switch Google account.
        if (auth.currentUser) {
          await signOut(auth);
        }

        const provider = new GoogleAuthProvider();
        provider.setCustomParameters({
          prompt: 'select_account consent'
        });
        const result = await signInWithPopup(auth, provider);
    
        const user = result.user;
        const token = await user.getIdToken(true);
        if (!token) return;

        const responseData: any = await $fetch("/users/connect-fb-g", {
          method: "POST",
          body: {
            firebaseToken: token,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });

        const errorMessage = responseData?.error_message;
        if (
          typeof errorMessage === "string" &&
          errorMessage.includes("Account already created with this email")
        ) {
          this.emailExist = true;
          // Sign out Firebase user so next attempt can choose another Google account.
          await signOut(auth);
          return;
        }

        if (responseData?.accessToken && responseData?.user?.id) {
          this.emailExist = false;
          cookie.value = responseData.accessToken;
          cookieId.value = responseData.user.id;
          if (isMobileAuthFlow()) {
            const callbackToken = encodeURIComponent(String(responseData.accessToken));
            window.location.replace(`topauto://callback?token=${callbackToken}`);
            return;
          }
          return navigateTo('/dashboard/home');
        }
      } catch (e) {
        const errorMessage =
          (e as any)?.data?.error_message ||
          (e as any)?.response?._data?.error_message ||
          "";
        if (
          typeof errorMessage === "string" &&
          errorMessage.includes("Account already created with this email")
        ) {
          this.emailExist = true;
          try {
            await signOut(auth);
          } catch (signOutError) {
            console.error("Google sign-out error:", signOutError);
          }
        } else {
          this.emailExist = false;
          console.error("Sign-in error:", e);
        }
      } finally {
        this.pendingAuth = false;
      }
    }
    
  },
  persist: createPersistedState({
    key: 'topauto:dashboard',
    version: 1,
    scope: 'user',
    paths: [
      'userProfil',
      'counters',
      'hasNewOffer'
    ]
  })
});
